import React from "react";
import { useLang } from "../context/LanguageContext";
import { useMenu, CATEGORY_KEYS, groupByCategory } from "../hooks/useMenu";

const Section = ({ title, items, lang, testid }) => (
  <div data-testid={testid} className="mb-20">
    <p className="overline text-[color:var(--wine)] mb-6 flex items-center">
      <span className="section-line"></span>
      {title}
    </p>
    <div className="space-y-1">
      {items.length === 0 && (
        <p className="py-4 text-[color:var(--ink-3)] text-sm italic">—</p>
      )}
      {items.map((item, i) => (
        <div
          key={item.id}
          data-testid={`${testid}-item-${i}`}
          className="flex items-start gap-3 py-5 border-b border-[color:var(--line)]"
        >
          <div className="flex-1 min-w-0">
            <div className="flex items-baseline gap-3 flex-wrap">
              <h4 className="font-serif-display text-2xl sm:text-3xl">
                {item[`name_${lang}`] || item.name_it}
              </h4>
              <span className="divider-dotted hidden sm:block" />
              <span className="font-serif-display text-2xl text-[color:var(--wine)] whitespace-nowrap">
                {item.price}
              </span>
            </div>
            <p className="mt-2 text-sm sm:text-base text-[color:var(--ink-3)] leading-relaxed max-w-xl">
              {item[`desc_${lang}`] || item.desc_it}
            </p>
          </div>
        </div>
      ))}
    </div>
  </div>
);

const MenuPage = () => {
  const { t, lang } = useLang();
  const { items, loading } = useMenu();
  const grouped = groupByCategory(items);

  const labels = {
    coffee: t.menu.categories.coffee,
    breakfast: t.menu.categories.breakfast,
    lunch: t.menu.categories.lunch_dinner,
    dessert: t.menu.categories.dessert,
  };

  return (
    <main data-testid="menu-page" className="pt-40 pb-20 lg:pt-48 lg:pb-32">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-10">
        <div className="mb-20">
          <p className="overline text-[color:var(--wine)] flex items-center">
            <span className="section-line"></span>
            {t.menu.eyebrow}
          </p>
          <h1 className="mt-6 font-serif-display text-6xl sm:text-7xl lg:text-8xl leading-[0.95] tracking-tight">
            {t.menu.title}
          </h1>
          <p className="mt-8 text-lg text-[color:var(--ink-2)] max-w-2xl leading-relaxed">
            {t.menu.subtitle}
          </p>
        </div>

        {loading ? (
          <p className="text-[color:var(--ink-3)]">…</p>
        ) : (
          CATEGORY_KEYS.map((cat) => (
            <Section
              key={cat}
              title={labels[cat]}
              items={grouped[cat]}
              lang={lang}
              testid={`menu-${cat}`}
            />
          ))
        )}
      </div>
    </main>
  );
};

export default MenuPage;
